// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea-module__textarea__haJns","invalid":"Textarea-module__invalid__4Lzcs"};